/*
 * ============================================================
 * GM WATCHES — CART PAGE JS
 * ============================================================
 * - ملخص الطلب: إجمالي المنتجات فقط بدون خصومات أو شحن
 * - تقدير الشحن: أداة منفصلة (لا تؤثر على الإجمالي)
 * - إصلاح تكرار GM.shipping
 * - تغيير "جنيه" إلى "EGP"
 */

(function () {
  'use strict';

  window.GMCartPage = window.GMCartPage || {};
  var GM = window.GMCartPage;

  GM.quantityBusy = false;

  /* ============================================================
     GM SHIPPING ESTIMATOR
     - Shopify is the source of province/rates.
     - Free-shipping threshold uses the SAME source as the
       existing free-shipping progress bar.
     ============================================================ */
  GM.shipping = GM.shipping || {
    requestId: 0,
    selectedProvince: '',
    provinceSelectedByUser: false,
    cache: {},
    lastShippingCents: null,
    lastCartKey: '',
    busy: false
  };

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);

    if (!isFinite(cents)) {
      cents = 0;
    }

    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var integerPart = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ','
    );

    return integerPart + '.' + parts[1] + ' EGP';
  }

  async function getCart() {
    /* Reuse the cart drawer's in-flight /cart.js request when available.
       This avoids two identical initial cart requests on the cart page. */
    if (
      window.GMCartDrawer &&
      typeof window.GMCartDrawer.getCart === 'function'
    ) {
      return window.GMCartDrawer.getCart();
    }

    var response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load cart.');
    }

    return response.json();
  }

  async function changeLine(line, quantity) {
    var response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: Number(line),
        quantity: Math.max(0, Number(quantity))
      })
    });

    if (!response.ok) {
      throw new Error('Unable to update cart.');
    }

    return response.json();
  }

  function setProductLoading(card, loading) {
    if (!card) return;

    if (loading) {
      card.classList.add('is-loading');
      card.setAttribute('aria-busy', 'true');
    } else {
      card.classList.remove('is-loading');
      card.removeAttribute('aria-busy');
    }

    qsa(
      '[data-cart-increase], [data-cart-decrease], [data-cart-remove]',
      card
    ).forEach(function (button) {
      button.disabled = loading;
    });
  }

  function getLineItem(cart, line) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }

    var index = Number(line) - 1;

    if (index < 0 || index >= cart.items.length) {
      return null;
    }

    return cart.items[index] || null;
  }

  function setLineQuantity(card, quantity) {
    var value = qs('[data-cart-quantity]', card);

    if (value) {
      value.textContent = String(quantity);
    } else {
      var fallback = qs(
        '.gm-cart-product__quantity-value',
        card
      );

      if (fallback) {
        fallback.textContent = String(quantity);
      }
    }
  }

  function setLinePrices(card, item) {
    if (!card || !item) return;

    var currentPrice = qs(
      '[data-product-price]',
      card
    );

    var oldPrice = qs(
      '[data-product-old-price]',
      card
    );

    var discountBadge = qs(
      '[data-product-discount-badge]',
      card
    );

    /*
     * مهم:
     * السعر الظاهر في صفحة السلة هو سعر المنتج الأساسي فقط.
     * لا نستخدم final_price/original_price هنا لأنهما قد يعكسان
     * خصم Shopify أو خصمًا مطبقًا على السلة.
     *
     * الخصومات الفعلية تُترك لصفحة Checkout.
     */
    var basePrice = Number(
      item.price != null
        ? item.price
        : item.final_price || 0
    );

    if (!Number.isFinite(basePrice)) {
      basePrice = 0;
    }

    if (currentPrice) {
      currentPrice.textContent =
        formatMoney(basePrice);
    }

    /*
     * Compare-at price يتم وضعه من Liquid في الـ HTML
     * لأنه غير مضمون أن يرجعه /cart.js.
     * لا نعيد حسابه من original_price.
     */
    var compareAtPrice =
      oldPrice && oldPrice.dataset.compareAtPrice
        ? Number(oldPrice.dataset.compareAtPrice)
        : 0;

    var hasOldPrice =
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > basePrice;

    if (oldPrice) {
      if (hasOldPrice) {
        oldPrice.textContent =
          formatMoney(compareAtPrice);

        oldPrice.hidden = false;
      } else {
        oldPrice.hidden = true;
      }
    }

    if (discountBadge) {
      discountBadge.hidden = !hasOldPrice;
    }
  }

  function getProductCard(line) {
    return qs(
      '.gm-cart-product[data-line="' +
        String(line) +
        '"]'
    );
  }

  function updateAllLineIndexes() {
    qsa('.gm-cart-product[data-line]').forEach(
      function (card, index) {
        var line = index + 1;

        card.dataset.line = String(line);

        qsa(
          '[data-cart-increase], [data-cart-decrease], [data-cart-remove]',
          card
        ).forEach(function (button) {
          button.dataset.line = String(line);
        });
      }
    );
  }

  function updateCartCount(cart) {
    var count = Number(
      (cart && cart.item_count) || 0
    );

    if (!Number.isFinite(count) || count < 0) {
      count = 0;
    }

    /*
     * تحديث كل أشكال عداد السلة:
     * 1) العداد المخصص في GM
     * 2) Dawn cart-count-bubble في الهيدر
     * 3) أي عنصر مخصص يحمل data-cart-count-bubble
     *
     * المشكلة السابقة كانت أن الصفحة كانت تحدث فقط
     * [data-cart-count]، لذلك كان عدد المنتجات يتغير داخل
     * بيانات السلة لكن الرقم أعلى أيقونة السلة قد يظل كما هو.
     */
    qsa('[data-cart-count]').forEach(function (element) {
      element.textContent = String(count);
    });

    qsa('[data-cart-count-bubble]').forEach(function (element) {
      element.textContent = String(count);
    });

    qsa(
      '.cart-count-bubble span[aria-hidden="true"],' +
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'
    ).forEach(function (element) {
      element.textContent = String(count);
    });

    qsa(
      '.cart-count-bubble .visually-hidden,' +
      '#cart-icon-bubble .cart-count-bubble .visually-hidden'
    ).forEach(function (element) {
      element.textContent =
        count === 1 ? '1 item' : String(count) + ' items';
    });

    qsa(
      '.cart-count-bubble,' +
      '#cart-icon-bubble .cart-count-bubble'
    ).forEach(function (bubble) {
      bubble.hidden = count <= 0;
      bubble.setAttribute('aria-hidden', count <= 0 ? 'true' : 'false');
    });

    /*
     * إخطار أي جزء آخر من GM بأن بيانات السلة أصبحت محدثة.
     * هذا لا يغير Business Logic؛ هو مجرد event للتزامن بين
     * صفحة السلة والهيدر/الأجزاء الأخرى.
     */
    try {
      document.dispatchEvent(
        new CustomEvent('gm:cart:updated', {
          detail: cart || null
        })
      );
    } catch (error) {
      /* CustomEvent غير متاح فقط في بيئات الاختبار القديمة. */
    }
  }

  /* ============================================================
     UPDATE SUMMARY — PRODUCTS TOTAL ONLY
     - لا يدخل الشحن في الإجمالي.
     - لا نضيف أي خصم من عندنا.
     - الإجمالي = السعر الحالي للمنتجات × الكمية.
     ============================================================ */
  function updateSummary(cart, shippingCents) {
    var totalElement = qs('[data-summary-total]');

    if (!cart || !totalElement) return;

    var total = 0;

    if (Array.isArray(cart.items)) {
      total = cart.items.reduce(function (sum, item) {
        /*
         * إجمالي السلة = السعر الأساسي للمنتج × الكمية.
         * لا نستخدم final_price حتى لا يظهر خصم Shopify داخل السلة.
         * ولا نضيف الشحن أو أي خصم عرض هنا.
         */
        var unitPrice = Number(
          item.price != null
            ? item.price
            : item.final_price || 0
        );

        var quantity = Number(item.quantity || 0);

        if (!Number.isFinite(unitPrice)) {
          unitPrice = 0;
        }

        if (!Number.isFinite(quantity) || quantity < 0) {
          quantity = 0;
        }

        return sum + (unitPrice * quantity);
      }, 0);
    }

    totalElement.textContent = formatMoney(total);
  }

  function getFreeShippingConfig() {
    var summaryWrapper = qs('#gm-cart-free-summary');

    if (
      summaryWrapper &&
      summaryWrapper.dataset.threshold
    ) {
      var localThreshold = Number(
        summaryWrapper.dataset.threshold
      );

      if (
        Number.isFinite(localThreshold) &&
        localThreshold > 0
      ) {
        return {
          thresholdCents: localThreshold
        };
      }
    }

    var source = qs('[data-gm-cart-shipping]');

    if (
      source &&
      source.dataset.gmShippingThreshold
    ) {
      var drawerThreshold = Number(
        source.dataset.gmShippingThreshold
      );

      if (
        Number.isFinite(drawerThreshold) &&
        drawerThreshold > 0
      ) {
        return {
          thresholdCents: drawerThreshold
        };
      }
    }

    return {
      thresholdCents: 190000
    };
  }

  function updateFreeShipping(cart) {
    var wrapper = qs('#gm-cart-free-summary');

    if (!wrapper) return;

    var message = qs(
      '[data-free-shipping-message]',
      wrapper
    );

    var progress = qs(
      '[data-free-shipping-progress]',
      wrapper
    );

    if (!message || !progress || !cart) {
      return;
    }

    var settings = getFreeShippingConfig();
    var threshold = settings.thresholdCents;
    var subtotal = Number(cart.total_price || 0);

    var approaching =
      wrapper.dataset.approachingText ||
      'أضف {amount} للحصول على الشحن المجاني';

    var free =
      wrapper.dataset.freeText ||
      '🎉 مبروك! حصلت على شحن مجاني';

    var percentage = Math.min(
      100,
      Math.max(
        0,
        (subtotal / threshold) * 100
      )
    );

    progress.style.width = percentage + '%';

    if (subtotal >= threshold) {
      message.innerHTML = free;
    } else {
      var remaining = formatMoney(threshold - subtotal);

      if (approaching.includes('{amount}')) {
        message.innerHTML = approaching.replace(
          '{amount}',
          '<strong>' + remaining + '</strong>'
        );
      } else {
        message.innerHTML =
          approaching +
          ' <strong>' +
          remaining +
          '</strong>';
      }
    }
  }

  function getShippingElements() {
    var wrapper = qs('[data-gm-shipping-estimator]');

    if (!wrapper) {
      return {
        wrapper: null,
        select: null,
        result: null
      };
    }

    return {
      wrapper: wrapper,
      select: qs('[data-gm-shipping-province]', wrapper),
      result: qs('[data-gm-shipping-result]', wrapper)
    };
  }

  function getCartSignature(cart) {
    if (!cart) return '';

    var items = Array.isArray(cart.items)
      ? cart.items.map(function (item) {
          return String(item.key || item.id || '') + ':' +
            String(item.quantity || 0);
        }).join('|')
      : '';

    return [
      String(cart.token || ''),
      String(cart.total_price || 0),
      String(cart.item_count || 0),
      items
    ].join('::');
  }

  function getShippingCacheKey(cart, province) {
    return getCartSignature(cart) + '::' + String(province || '');
  }

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function buildShippingUrl(endpoint, province) {
    var root = getShopifyRoot();
    var url = root + 'cart/' + endpoint + '.json';
    var params = new URLSearchParams();

    params.set('shipping_address[country]', 'Egypt');
    params.set('shipping_address[province]', province);

    return url + '?' + params.toString();
  }

  function setShippingResult(message, state) {
    var elements = getShippingElements();

    if (!elements.result) return;

    elements.result.classList.remove('is-loading', 'is-error');

    if (state === 'loading') {
      elements.result.classList.add('is-loading');
    } else if (state === 'error') {
      elements.result.classList.add('is-error');
    }

    elements.result.innerHTML = message || '';
  }

  function renderShippingCost(shippingCents) {
    if (Number(shippingCents) <= 0) {
      setShippingResult('تكلفة الشحن: <strong>مجانًا</strong>');
      return;
    }

    setShippingResult(
      'تكلفة الشحن: <strong>' +
        formatMoney(shippingCents) +
      '</strong>'
    );
  }

  function getShippingRates(payload) {
    if (!payload || !Array.isArray(payload.shipping_rates)) {
      return [];
    }

    return payload.shipping_rates
      .map(function (rate) {
        var price = Number(rate && rate.price);

        if (!Number.isFinite(price) || price < 0) {
          return null;
        }

        return {
          priceCents: Math.round(price * 100),
          name: rate.presentment_name || rate.name || ''
        };
      })
      .filter(Boolean);
  }

  async function prepareShippingRates(province, signal) {
    var url = buildShippingUrl('prepare_shipping_rates', province);

    var response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      signal: signal
    });

    if (!response.ok) {
      throw new Error('Unable to prepare shipping rates.');
    }

    return response;
  }

  async function fetchShippingRatesDirect(province, signal) {
    var url = buildShippingUrl('shipping_rates', province);

    var response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      signal: signal
    });

    if (!response.ok) {
      return null;
    }

    return response.json();
  }

  async function fetchAsyncShippingRates(province, signal) {
    var url = buildShippingUrl('async_shipping_rates', province);

    var response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      signal: signal
    });

    if (!response.ok) {
      throw new Error('Unable to read shipping rates.');
    }

    return response.json();
  }

  function getLowestShippingRate(payload) {
    var rates = getShippingRates(payload);

    if (!rates.length) {
      return null;
    }

    return rates.reduce(function (lowest, rate) {
      if (!lowest || rate.priceCents < lowest.priceCents) {
        return rate;
      }

      return lowest;
    }, null);
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  async function calculateShopifyShipping(province, requestId) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () {
      controller.abort();
    }, 12000);

    try {
      if (requestId !== GM.shipping.requestId) {
        return null;
      }

      var directPayload = await fetchShippingRatesDirect(
        province,
        controller.signal
      );

      var directRate = getLowestShippingRate(directPayload);

      if (directRate) {
        return directRate;
      }

      await prepareShippingRates(province, controller.signal);

      for (var attempt = 0; attempt < 10; attempt += 1) {
        if (requestId !== GM.shipping.requestId) {
          return null;
        }

        var payload = await fetchAsyncShippingRates(
          province,
          controller.signal
        );

        var rate = getLowestShippingRate(payload);

        if (rate) {
          return rate;
        }

        await sleep(650);
      }

      return null;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function updateShippingEstimate(cart) {
    var elements = getShippingElements();

    if (!elements.wrapper || !elements.select || !elements.result) {
      GM.shipping.lastShippingCents = null;
      GM.shipping.lastCartKey = '';
      return;
    }

    var province = elements.select.value || '';
    GM.shipping.selectedProvince = province;

    if (GM.shipping.provinceSelectedByUser !== true || !province) {
      GM.shipping.requestId += 1;
      GM.shipping.lastShippingCents = null;
      GM.shipping.lastCartKey = '';
      GM.shipping.busy = false;

      elements.select.value = '';
      elements.select.selectedIndex = 0;
      setShippingResult('');
      return;
    }

    if (!cart || !cart.item_count) {
      GM.shipping.requestId += 1;
      GM.shipping.lastShippingCents = null;
      GM.shipping.lastCartKey = '';
      elements.select.value = '';
      setShippingResult('');
      return;
    }

    if (!province) {
      GM.shipping.requestId += 1;
      GM.shipping.lastShippingCents = null;
      GM.shipping.lastCartKey = '';
      setShippingResult('');
      return;
    }

    var config = getFreeShippingConfig();
    var subtotal = Number(cart.total_price || 0);

    if (
      config &&
      Number.isFinite(Number(config.thresholdCents)) &&
      Number(config.thresholdCents) > 0 &&
      subtotal >= Number(config.thresholdCents)
    ) {
      GM.shipping.requestId += 1;
      GM.shipping.lastShippingCents = 0;
      GM.shipping.lastCartKey = getShippingCacheKey(cart, province);
      renderShippingCost(0);
      return;
    }

    var cacheKey = getShippingCacheKey(cart, province);

    if (
      GM.shipping.lastCartKey === cacheKey &&
      Number.isFinite(Number(GM.shipping.lastShippingCents))
    ) {
      renderShippingCost(GM.shipping.lastShippingCents);
      return;
    }

    if (Object.prototype.hasOwnProperty.call(GM.shipping.cache, cacheKey)) {
      var cached = GM.shipping.cache[cacheKey];
      GM.shipping.lastShippingCents = cached;
      GM.shipping.lastCartKey = cacheKey;
      renderShippingCost(cached);
      return;
    }

    var requestId = GM.shipping.requestId + 1;
    GM.shipping.requestId = requestId;
    GM.shipping.busy = true;

    setShippingResult('جارٍ حساب تكلفة الشحن…', 'loading');

    try {
      var rate = await calculateShopifyShipping(province, requestId);

      if (requestId !== GM.shipping.requestId) {
        return;
      }

      if (!rate) {
        GM.shipping.lastShippingCents = null;
        GM.shipping.lastCartKey = '';
        setShippingResult(
          'تعذر حساب تكلفة الشحن لهذه المحافظة حاليًا.',
          'error'
        );
        return;
      }

      var shippingCents = Math.max(0, Number(rate.priceCents || 0));

      GM.shipping.cache[cacheKey] = shippingCents;
      GM.shipping.lastShippingCents = shippingCents;
      GM.shipping.lastCartKey = cacheKey;

      renderShippingCost(shippingCents);
    } catch (error) {
      if (requestId !== GM.shipping.requestId) {
        return;
      }

      console.error('[GM Cart Shipping]', error);
      GM.shipping.lastShippingCents = null;
      GM.shipping.lastCartKey = '';
      setShippingResult(
        'تعذر حساب تكلفة الشحن حاليًا، حاول مرة أخرى.',
        'error'
      );
    } finally {
      if (requestId === GM.shipping.requestId) {
        GM.shipping.busy = false;
      }
    }
  }

  function initShippingEstimator() {
    var elements = getShippingElements();

    if (!elements.select || elements.select.dataset.gmInitialized === 'true') {
      return;
    }

    elements.select.dataset.gmInitialized = 'true';

    elements.select.value = '';
    elements.select.selectedIndex = 0;
    GM.shipping.selectedProvince = '';
    GM.shipping.provinceSelectedByUser = false;

    elements.select.addEventListener('change', function () {
      GM.shipping.selectedProvince = elements.select.value || '';
      GM.shipping.provinceSelectedByUser = !!elements.select.value;

      getCart()
        .then(function (cart) {
          updateShippingEstimate(cart);
        })
        .catch(function (error) {
          console.error('[GM Cart Shipping Province]', error);
          setShippingResult(
            'تعذر تحديث تكلفة الشحن حاليًا، حاول مرة أخرى.',
            'error'
          );
        });
    });
  }

  function refreshCartUI(cart) {
    if (!cart) return;

    updateCartCount(cart);
    updateFreeShipping(cart);
    updateShippingEstimate(cart);
    updateSummary(cart);
  }

  async function handleQuantity(button, increase) {
    if (GM.quantityBusy) return;

    var line = Number(button.dataset.line);

    if (!line) return;

    var card = getProductCard(line);

    if (!card) return;

    try {
      GM.quantityBusy = true;
      setProductLoading(card, true);

      var cart = await getCart();
      var item = getLineItem(cart, line);

      if (!item) {
        window.location.reload();
        return;
      }

      var newQuantity = increase
        ? Number(item.quantity) + 1
        : Math.max(0, Number(item.quantity) - 1);

      var updatedCart = await changeLine(line, newQuantity);

      if (newQuantity === 0) {
        card.style.transition = 'opacity .2s ease, transform .2s ease';
        card.style.opacity = '0';
        card.style.transform = 'translateY(-4px)';

        setTimeout(function () {
          window.location.reload();
        }, 180);

        return;
      }

      var updatedItem = getLineItem(updatedCart, line);

      if (updatedItem) {
        setLineQuantity(card, updatedItem.quantity);
        setLinePrices(card, updatedItem);
      }

      refreshCartUI(updatedCart);
    } catch (error) {
      console.error('[GM Cart Quantity]', error);
    } finally {
      setProductLoading(card, false);
      GM.quantityBusy = false;
    }
  }

  async function handleRemove(button) {
    if (GM.quantityBusy) return;

    var line = Number(button.dataset.line);

    if (!line) return;

    var card = getProductCard(line);

    if (!card) return;

    try {
      GM.quantityBusy = true;
      setProductLoading(card, true);

      var updatedCart = await changeLine(line, 0);

      card.style.transition = 'opacity .22s ease, transform .22s ease';
      card.style.opacity = '0';
      card.style.transform = 'translateY(-5px)';

      await new Promise(function (resolve) {
        window.setTimeout(resolve, 220);
      });

      if (card && card.parentNode) {
        card.parentNode.removeChild(card);
      }

      if (!updatedCart.item_count) {
        window.location.reload();
        return;
      }

      updateAllLineIndexes();
      refreshCartUI(updatedCart);
    } catch (error) {
      console.error('[GM Cart Remove]', error);
      setProductLoading(card, false);
    } finally {
      GM.quantityBusy = false;
    }
  }

  function initQuantityButtons() {
    qsa('[data-cart-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.disabled) {
          handleQuantity(btn, true);
        }
      });
    });

    qsa('[data-cart-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.disabled) {
          handleQuantity(btn, false);
        }
      });
    });

    qsa('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.disabled) {
          handleRemove(btn);
        }
      });
    });
  }

  /* ============================================================
     GM CHECKOUT
     ============================================================ */
  function initCheckoutButton() {
    qsa('[data-cart-checkout]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var checkoutUrl = button.getAttribute('href');

        if (!checkoutUrl) {
          checkoutUrl = '/checkout';
        }

        window.location.href = checkoutUrl;
      });
    });
  }

  async function initDynamicData() {
    try {
      var cart = await getCart();
      refreshCartUI(cart);
    } catch (error) {
      console.error('[GM Cart Dynamic Data]', error);
    }
  }

  function init() {
    initQuantityButtons();
    initCheckoutButton();
    initShippingEstimator();
    initDynamicData();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();